module.exports = __webpack_public_path__ + "img/step3.89327cf2.svg";